const STRIPE_ERROR_MESSAGES: Record<string, string> = {
  card_declined:
    'Your card was declined. Please try a different payment method.',
  expired_card: 'Your card has expired. Please update your payment method.',
  insufficient_funds:
    'Insufficient funds. Please try a different payment method.',
  incorrect_cvc: 'The security code is incorrect. Please check and try again.',
  incorrect_number: 'The card number is incorrect. Please check and try again.',
  processing_error:
    'An error occurred while processing your card. Please try again.',
  authentication_required:
    'Your bank requires additional authentication. Please try again.',
};

const BACKEND_ERROR_MESSAGES: Record<string, string> = {
  payment_failed: 'The payment could not be completed. Please try again.',
  payment_method_invalid:
    'This payment method is no longer valid. Please add a new one.',
  payment_method_expired: 'Your payment method has expired. Please update it.',
  charge_failed:
    'We were unable to charge your payment method. Please try a different one.',
};

export function translatePaymentError(code: string): string {
  return (
    STRIPE_ERROR_MESSAGES[code] ||
    BACKEND_ERROR_MESSAGES[code] ||
    'A payment error occurred. Please try again or use a different payment method.'
  );
}
